import React from "react"
import { GridItem, Box, Flex, Text, LinkBox, LinkOverlay } from "@chakra-ui/react"
import Link from "@app/components/Link"
import { useRoutes } from "@app/hooks/useRoutes"
import { useConfigContext } from "@app/providers/config"
import ProductPriceRange from "@app/components/Product/ProductPriceRange"
import Image from "@app/components/Image/Image"

type Props = {
  item: any
  itemRef?: any
  handleTrackingClick?: () => void
}

const FeaturedProductsItem: React.FC<Props> = ({ item, itemRef, handleTrackingClick = () => null }) => {
  const {
    settings: { routes },
  } = useConfigContext()
  const { urlResolver } = useRoutes()

  return (
    <GridItem ref={itemRef} key={item?.title?.toString()} colSpan={1}>
      <LinkBox>
        <Flex justifyContent="center" alignItems="center" h={["unset", "300px"]} mb={4}>
          <Image src={item?.images[0]?.src} alt={item?.title} h={["unset", "90%"]} maxW="100%" />
        </Flex>
        <Box textAlign="center">
          <LinkOverlay
            as={Link}
            to={item?.link?.url || urlResolver(item, routes.PRODUCT)?.url}
            title={item?.title}
            onClick={handleTrackingClick}
          >
            <Text as="h3" size="lg" fontWeight="600">
              {item?.title}
            </Text>
          </LinkOverlay>
          <ProductPriceRange product={item} />
        </Box>
      </LinkBox>
    </GridItem>
  )
}

export default React.memo(FeaturedProductsItem)
